<template>
  <div :class="['payment-date-options', { 'mobile': isMobile }]">
    <div class="radio-group">
      <div
        :class="['radio-wrapper', { 'active': index === activeInputIndex }]"
        v-for="([day, month], index) in dateOptions"
        :key="index"
        @click="() => onSelect(index)"
        @tap="() => onSelect(index)"
      >
        <input
          v-if="!isMobile"
          class="radio-input"
          :id="`date-${index}`"
          type="radio"
          name="date-option"
          :checked="index === activeInputIndex"
        />
        <label class="radio-label" :for="`date-${index}`">
          <span v-if="isMobile" class="label-mobile">
            <span class="label-day">{{ day }}</span>
            <span class="label-month">{{ month }}</span>
          </span>
          <span v-else>{{ day + ' ' + month }}</span>
        </label>
      </div>
    </div>
    <span class="footer">
      As demais parcelas vencerão mensalmente todo dia {{ footerDate }}
    </span>
  </div>
</template>

<script>
import moment from '@/lib/moment-ptbr';
import isMobile from '@/lib/isMobile';

export default {
  name: 'payment-date-options',
  props: {
    dateOptions: {
      type: Array,
      required: true,
      validator(value) {
        return value.reduce((response, dateOption) => {
          if (!response
            || !Array.isArray(dateOption)
            || dateOption.length !== 2
            || typeof dateOption[0] !== 'string'
            || typeof dateOption[1] !== 'string') return false;
          return response;
        }, true);
      },
    },
  },
  components: {},
  data: () => ({
    dayOptions: [5, 10, 15, 25],
    standardDeadline: [1, 'months'],
    activeInputIndex: 0,
    isMobile: false,
  }),
  computed: {
    footerDate() {
      return this.dateOptions[this.activeInputIndex][0];
    },
  },
  methods: {
    onSelect(index) {
      this.activeInputIndex = index;
      this.$emit('dueDateSelect', index);
    },
    getDateOptions() {
      const standardDueDate = moment().add(...this.standardDeadline);
      return this.dayOptions
        .map((dayOption) => {
          const dateMonth = dayOption <= standardDueDate.date()
            ? standardDueDate.month() + 1
            : standardDueDate.month();
          return moment().month(dateMonth).date(dayOption);
        })
        .sort((a, b) => (moment(a).isBefore(b) ? -1 : 1));
    },
  },
  mounted() {
    this.isMobile = isMobile();
  },
};
</script>

<style lang="scss" scoped>
.radio-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  cursor: pointer;

  height: 16px;
  width: 16px;
  border-radius: 50%;
  margin: 0;
  padding: 0;

  background: #F8FAFC;
  border: 1px solid #CBD5E1;

  &:checked {
    border: 4px solid var(--primary);
  }
}

.radio-label {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;

  cursor: pointer;
}

.label-mobile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .label-day {
    font-size: 16px;
    font-weight: 700;
  }

  .label-month {
    font-size: 12px;
    line-height: 14px;
  }
}

.radio-wrapper {
  display: flex;
  align-items: center;
  height: 24px;
  padding: 0 8px 0 4px;
  gap: 4px;
  border: 1px solid var(--gray-200);
  border-radius: 12px;

  &:hover {
    border: 1px solid var(--primary);
  }

  &.active {
    background-color: var(--primary-extra-light);
    border: 1px solid var(--primary);
  }
}

.footer {
  @extend .gray-500;
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.payment-date-options {
  display: flex;
  flex-direction: column;
  margin: 0;
  gap: 8px;
}

.radio-group {
    display: flex;
    gap: 24px;
}

.mobile {
  .radio-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    border: 0;
    padding: 0;
    justify-content: center;
    background: #F1F5F9;
  }

  .radio-wrapper.active {
    background: #36A3CA;
    color: white;
  }

  .radio-group {
    display: flex;
    width: 100%;
    padding: 4px 0;
    gap: 20px;
  }

  .footer {
    font-size: 12px;
    line-height: 24px;
    width: 100%;
  }

  .payment-date-options {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px;
    border: 1px solid #E2E8F0;
    border-radius: 4px;
  }
}
</style>
